import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import GeoSearchInput from '../../components/geo-search-input';
import SearchMapContainer from '../../components/search-map-container';
import * as selectors from '../../reducers';
import styles from './search-page.module.scss';
import {
  setActiveRegion,
  setActivePage,
  setActiveEntity,
} from '../../actions/ui';
import { ChevronDoubleRight } from '../../components/icons';
import { entityLabelMatcher } from '../../helpers/label-mapper';
import DroughtVis from '../../components/drought-vis';

class SearchPage extends Component {
  constructor() {
    super();
    this.selectCouncil = this.selectCouncil.bind(this);
    this.handleListClick = this.handleListClick.bind(this);
  }
  selectCouncil(councilId) {
    const { setActiveRegion, setActivePage } = this.props;
    setActiveRegion(councilId);
    setActivePage('region');
  }

  selectEntity(entityId) {
    const { setActiveEntity, setActivePage } = this.props;

    setActiveEntity(entityId);
    setActivePage('entity');
  }

  handleListClick(council) {
    return (e) => {
      window.scrollTo(0, 0);
      this.selectCouncil(council.id);
    };
  }

  handleEntityListClick(entity) {
    return (e) => {
      window.scrollTo(0, 0);
      this.selectEntity(entity.id);
    };
  }

  renderCouncils() {
    const { regions } = this.props;
    return (
      <ul className={styles.councilList}>
        {regions
          .filter((c) => {
            // Don't make a page for the "Other- inside or outside QLD" category
            return !c.name.includes('Other');
          })
          .map((council, i) => (
            <li key={i} className={styles.councilListElement}>
              <button
                type="button"
                className={styles.councilListElementButton}
                onClick={this.handleListClick(council)}
              >
                {council.lgaName}
              </button>
            </li>
          ))}
      </ul>
    );
  }
  render() {
    var entityGroupOrdering = {}, // map for efficient lookup of sortIndex
      entityGroupSortOrder = [
        'Bulk water supplier',
        'Distributor-retailers',
        'Category 1 water board',
      ];

    for (var i = 0; i < entityGroupSortOrder.length; i++) {
      entityGroupOrdering[entityGroupSortOrder[i]] = i;
    }

    var entityOrdering = {}, // map for efficient lookup of sortIndex
      entitySortOrder = [
        'Seqwater',
        'Sunwater',
        'Urban Utilities',
        'Unitywater',
        'GAWB',
        'MIWB',
      ];

    for (var k = 0; k < entitySortOrder.length; k++) {
      entityOrdering[entitySortOrder[k]] = k;
    }

    const entityGroups = Object.keys(groupBy(this.props.entities, 'entityType'))
      .filter(function (x) {
        return x !== 'Council managed';
      })
      .sort(function (a, b) {
        return (
          entityGroupOrdering[a] - entityGroupOrdering[b] || a.localeCompare(b)
        );
      });

    const allEntities = this.props.entities.sort(function (a, b) {
      return (
        entityOrdering[a.name] - entityOrdering[b.name] ||
        a.name.localeCompare(b.name)
      );
    });

    return (
      <div>
        <div className={styles.searchPageHeader}>
          <div className={styles.mainHeading}>
            Understanding your water services in 2021
          </div>
          <hr className={styles.mainHeadingLine} />
          <div className={styles.subHeading}>
            This Queensland Audit Office interactive map of Queensland allows
            you to explore the financial performance of the state's water
            entities, and view storage levels, the number of dams, and drought
            declared areas across the state. You can find information on your
            water services by typing your address into the search bar or
            clicking on your local council.
          </div>
        </div>
        <div className={styles.section}>
          <h3 className={styles.sectionHeading}>Search the map</h3>
          <div className={styles.searchWrapper}>
            <GeoSearchInput onCouncilSelect={this.selectCouncil} />
          </div>
          <div className={styles.mapRow}>
            <div className={styles.mapWrapper}>
              <SearchMapContainer onCouncilSelect={this.selectCouncil} />
            </div>
            <div className={styles.entityListWrapper}>
              <h4>Entities</h4>
              <ul>
                {entityGroups.map((groupName, i) => {
                  const entitiesInClass = this.props.entities.filter(
                    (x) => x.entityType === groupName
                  );

                  return entitiesInClass
                    ? [
                        <li key={groupName + i}>
                          <p className={styles.subHeading}>
                            {entityLabelMatcher(groupName, 'plural')}
                          </p>
                        </li>,
                        allEntities
                          .filter((x) => x.entityType === groupName)
                          .map((e) => {
                            return (
                              <li
                                onClick={this.handleEntityListClick(e)}
                                key={e.name}
                                role="button"
                                className={styles.li}
                              >
                                <ChevronDoubleRight
                                  fill="blue"
                                  width="10px"
                                  height="10px"
                                  style={{
                                    marginRight: 10,
                                    height: 10,
                                    width: 10,
                                  }}
                                />
                                {entityLabelMatcher(e.name, 'singular')}
                              </li>
                            );
                          }),
                      ]
                    : null;
                })}
              </ul>
              <p
                className={styles.subHeading}
                style={{ paddingTop: 10, paddingBottom: 5 }}
              >
                LGA drought status (1 Aug 2021)
              </p>
              <DroughtVis />
            </div>
          </div>
        </div>

        <div className={styles.section}>
          <h3 className={styles.sectionHeading}>Select LGA from list</h3>
          <div className={styles.listWrapper}>{this.renderCouncils()}</div>
        </div>
      </div>
    );
  }
}

var groupBy = function (xs, key) {
  return xs.reduce(function (rv, x) {
    (rv[x[key]] = rv[x[key]] || []).push(x);
    return rv;
  }, {});
};

const mapDispatchToProps = {
  setActiveRegion,
  setActivePage,
  setActiveEntity,
};

const mapStateToProps = (state) => ({
  regions: selectors.getRegions(state),
  entities: selectors.getEntities(state),
});

SearchPage.propTypes = {
  regions: PropTypes.arrayOf(PropTypes.object),
  entities: PropTypes.arrayOf(PropTypes.object),
  setActiveRegion: PropTypes.func,
  setActivePage: PropTypes.func,
  setActiveEntity: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(SearchPage);



// WEBPACK FOOTER //
// ./src/pages/search-page/search-page.js